import React from 'react'
import IcoMoon from 'react-icomoon'
import iconSet from '../assets/icons/selection.json'

export default function CustomIcon({ name, ...props }) {
  return <IcoMoon iconSet={iconSet} icon={name} {...props} disableFill={true} />
}
